module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_IS-2d8772f4698141bf7dce02083d7c938a.svg";